export class GoogleAnalyticsTracker {
    serviceName = 'ga';
    #eventData;

    constructor(eventData) {
        this.#eventData = eventData;
    }

    firePixelEvent(eventName) {
        // pass
    }

    firePurchaseEvent(price, orderID, currency) {
        // Google Analytics goal tracking - fired from tag manager using these values
        window.product_price = price;
        window.product_page = this.#eventData.title;

        this.#triggerEvent('purchase', {
            transaction_id: orderID,
            items: this.#createItemsProperty(price),
            value: price,
            currency,
        });
    }

    fireCheckoutStartedEvent() {
        this.#triggerEvent('begin_checkout', {
            currency: this.#eventData.currency,
            items: this.#createItemsProperty(),
            value: 0,
        });
    }

    fireAddPaymentInfoEvent(paymentType) {
        this.#triggerEvent('add_payment_info', {
            currency: this.#eventData.currency,
            items: this.#createItemsProperty(),
            payment_type: paymentType,
            value: 0,
        });
    }

    #triggerEvent(eventName, eventData) {
        if (typeof dataLayer === 'undefined') {
            return;
        }

        dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
        dataLayer.push({
            event: eventName,
            ecommerce: eventData,
        });
    }

    #createItemsProperty(price = 0) {
        return [
            {
                item_id: this.#eventData.name,
                item_name: this.#eventData.title,
                price,
            },
        ];
    }
}
